import React from 'react'
import { GAME_TOKEN_MERAH } from "assets/images"

const MemoizedImageMERAH = () => {
  return (
    <img src={GAME_TOKEN_MERAH} alt='' className='game-token-merah' loading="lazy" />
  )
}
export default React.memo(MemoizedImageMERAH) 
